{
  "login": "login",
  "welcome": "welcome",
  "sign-up": "sign-up",
  "vendor": "vendor",
  "vendor_profile": "vendor-profile",
  "kyc_documents": "vendor-profile",
  "add_contact": "vendor-profile",
  "edit_vendor": "vendor-profile",
  "fp": "forgot-password",
  "rp": "reset-password",
  "support": "support",
  "event": "event",
  "orders": "orders",
  "alert_notifications": "alert-notifications",
  "contract": "contract",
  "tenant_invitations": "tenant-invitations",
  "fast_catalogue": "fast-catalogue"
}
